import ContentContainer from "layout/Content/ContentContainer";
import Trans from "features/translation/components/Trans";
import useData from "hooks/useData";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

const Maintenance = () => {
  const { getData } = useData();
  const history = useHistory();
  const interval = useRef();

  const checkMaintenance = async () => {
    const { response } = await getData('stb/user', '', true, false);
    const status = response?.status;
    if (status && status !== 503) {
      history.push('/');
    }
  }

  useEffect(
    () => {
      interval.current = setInterval(() => checkMaintenance(), 15000);
      return () => clearInterval(interval.current);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  return (
    <ContentContainer contentBackground={ true }
                      contentPadding={ true }
                      contentGridType={ 'small' }
                      containerPadding={ true }>
      <h1><Trans text="Even geduld alstublieft"/></h1>
      <p>Vanwege onderhoud is de site even niet bereikbaar, dit duurt normaal gesproken hoogstens een paar minuten.</p>
      <p><strong>Zodra het onderhoud klaar is ververst deze pagina automatisch...</strong></p>
    </ContentContainer>
  )
}

export default Maintenance;
